module.exports = __webpack_public_path__ + "static/Prof.SuzinaSheikhAbHamidPhDMALAYSIA-e6282e6959a165dc2765c2d06bdd98f0.jpg";